"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const HeaderFixed_vue_1 = tslib_1.__importDefault(require("../components/HeaderFixed.vue"));
const FooterFixed_vue_1 = tslib_1.__importDefault(require("../components/FooterFixed.vue"));
const Navigation_vue_1 = tslib_1.__importDefault(require("../components/Navigation.vue"));
const HomeSection_vue_1 = tslib_1.__importDefault(require("../views/HomeSection.vue"));
const ClientsSection_vue_1 = tslib_1.__importDefault(require("../views/ClientsSection.vue"));
const PortfolioSection_vue_1 = tslib_1.__importDefault(require("../views/PortfolioSection.vue"));
const Footer_vue_1 = tslib_1.__importDefault(require("../components/Footer.vue"));
const config_1 = require("@/config");
exports.default = {
    name: 'Layout',
    components: {
        HeaderFixed: HeaderFixed_vue_1.default,
        FooterFixed: FooterFixed_vue_1.default,
        Navigation: Navigation_vue_1.default,
        HomeSection: HomeSection_vue_1.default,
        ClientsSection: ClientsSection_vue_1.default,
        PortfolioSection: PortfolioSection_vue_1.default,
        Footer: Footer_vue_1.default,
    },
    setup() {
        const switchSection = (event) => {
            const element = document.getElementById(event);
            const top = element.offsetTop;
            window.scrollTo(0, top);
        };
        const isPanelOpen = (0, vue_1.ref)(false);
        const hideWrapper = (event) => {
            isPanelOpen.value = event;
        };
        (0, vue_1.onMounted)(() => {
            window.scrollTo(0, 0);
        });
        return {
            NavigationTabLabel: config_1.NavigationTabLabel,
            switchSection,
            hideWrapper,
        };
    },
};
